import React from 'react';

import { bemCssModules, correctingTrailingNumbers } from '@cryptoboyio/mercuryo-lab/utils';

import { getTestId } from '@utils';

import style from '../Transactions.scss';

const cn = bemCssModules(style, 'Transactions');
const ti = getTestId('Transactions');

export type AmountType = {
  status: string;
  type: string;
  amount: string;
  displayDigits?: number;
  totalDigits?: number;
  testId?: string;
};

export const Amount: CustomFC<AmountType> = props => {
  const { status, type, amount, displayDigits, totalDigits, testId } = props;

  return (
    <span className={cn('amount', { status, type })} data-testid={ti(testId)}>
      {correctingTrailingNumbers(amount, displayDigits, totalDigits)}
    </span>
  );
};

export default Amount;
